export default "__VITE_ASSET__a203483e__"